import React from 'react';
import { useTranslation } from 'react-i18next';

import FarmShareBG from '../../assets/FarmshareBG.jpg';
import { EquipmentFilter } from '../../components/EquipmentFilter';
import { EquipmentList } from '../../components/EquipmentList';
import { FarmshareEquipmentGrid } from '../../components/farmshare/FarmshareEquipmentGrid';
import { FarmshareFilterComponent } from '../../components/farmshare/FarmshareFilterComponent';
import { FarmshareNavigationTabs } from '../../components/farmshare/FarmshareNavigationTabs';
import { Navbar } from '../../components/Navbar';

const FarmsharePage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-SLIWhite">
      <Navbar
        src={FarmShareBG}
        pageName={t('farmshareInProgress.navbar.pageName')}
        pageText={t('farmshareInProgress.navbar.pageText')}
      />
      <div className="page-responsive-x-padding">
        <FarmshareNavigationTabs />
        <div className="flex">
          <div className="min-w-56 flex-[2] mr-8 flex flex-col">
            {/* <EquipmentFilter /> */}
            <FarmshareFilterComponent />
          </div>
          <div className="flex-[7] flex flex-col">
            <FarmshareEquipmentGrid />
            {/* <EquipmentList /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export { FarmsharePage };
